import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from "@angular/core";
import {ControlContainer, NgForm} from "@angular/forms";
import {ToastService} from "../../../../services/toast/toast.service";
import {ConteudoRim} from "../../../../core/conteudo-rim";
import {ConsultaBanco} from "../../../../core/consulta-banco";

@Component({
    selector: "conteudo-paragrafo-rim",
    templateUrl: "./conteudo-paragrafo-rim.component.html",
    styleUrls: ["./conteudo-paragrafo-rim.component.css"],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class ConteudoParagrafoRimComponent implements OnInit {

    @Input() conteudo: ConteudoRim;
    @Input() index: number;
    @Input() camposDesabilitados: boolean;
    @ViewChild('ckeditor') ckeditor: any;

    pinRandom = Math.random();

    valorSelecionado: ConsultaBanco;

    config = {
        versionCheck: false,
        toolbar: [
            ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "CopyFormatting", "RemoveFormat"],
            ["Format", "FontSize"],
            ["TextColor", "BGColor"],
            ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"],
            ["Link", "Unlink"],
            ["SpecialChar", "Find", "Replace", "SelectAll"],
            ["Cut", "Copy"],
            ["Maximize", "Undo", "Redo"],
        ],
    };

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    onValorSelecionado(registro: any) {
        this.valorSelecionado = registro;
    }

    addValoreSelecionado() {
        if (!this.conteudo.descricao)
            this.conteudo.descricao = '';

        const valor = '#{' + this.valorSelecionado.codigo + '}';

        // Get CKEditor instance
        const editor = this.ckeditor.instance;

        // Insert text at cursor position
        editor.insertText(valor);

        this.valorSelecionado = null;
    }

    copiarValorParaCopyPaste() {
        if (this.valorSelecionado) {
            navigator.clipboard.writeText('#{' + this.valorSelecionado.codigo + '}').then(() => {
                this.toastService.showSucesso("Valor copiado para a área de transferência.");
                this.valorSelecionado = null;
            }, () => {
                this.toastService.showAlerta("Erro ao copiar valor para a área de transferência.");
            });
        }
    }

}
